import React, { Component } from 'react';

// cd C:\Users\xmobl\Documents\Smilefish\Smilestein\SmileStein-Client
// cd C:\Users\xmobl\Documents\Smilefish\Smilestein\SmileStein-Server

class App extends Component {

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default App;
